export const pricingData = {
  'Delhi (NCR)': {
    'Sedan': {
      baseCharge: 1500,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 18,
      extraHourRate: 150,
      nightCharges: 300,
      outstationMinKms: 250,
      outstationRate: 18,
      driverAllowance: 300,
      localPackages: {
        '2hr-20km': 800,
        '3hr-30km': 1000,
        '4hr-40km': 1200,
        '5hr-50km': 1400,
        '6hr-60km': 1600,
        '7hr-70km': 1800,
        '8hr-80km': 2000,
        '9hr-90km': 2200,
        '10hr-100km': 2400
      }
    },
    'SUV': {
      baseCharge: 2000,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 22,
      extraHourRate: 200,
      nightCharges: 400,
      outstationMinKms: 250,
      outstationRate: 22,
      driverAllowance: 400,
      localPackages: {
        '2hr-20km': 1200,
        '3hr-30km': 1400,
        '4hr-40km': 1600,
        '5hr-50km': 1800,
        '6hr-60km': 2000,
        '7hr-70km': 2200,
        '8hr-80km': 2400,
        '9hr-90km': 2600,
        '10hr-100km': 2800
      }
    },
    'Premium Sedan': {
      baseCharge: 2200,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 24,
      extraHourRate: 220,
      nightCharges: 400,
      outstationMinKms: 250,
      outstationRate: 24,
      driverAllowance: 400,
      localPackages: {
        '2hr-20km': 1400,
        '3hr-30km': 1600,
        '4hr-40km': 1800,
        '5hr-50km': 2000,
        '6hr-60km': 2200,
        '7hr-70km': 2400,
        '8hr-80km': 2600,
        '9hr-90km': 2800,
        '10hr-100km': 3000
      }
    },
    'Premium SUV': {
      baseCharge: 3000,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 30,
      extraHourRate: 300,
      nightCharges: 500,
      outstationMinKms: 250,
      outstationRate: 30,
      driverAllowance: 500,
      localPackages: {
        '2hr-20km': 1800,
        '3hr-30km': 2000,
        '4hr-40km': 2200,
        '5hr-50km': 2400,
        '6hr-60km': 2600,
        '7hr-70km': 2800,
        '8hr-80km': 3000,
        '9hr-90km': 3200,
        '10hr-100km': 3400
      }
    },
    'Luxury': {
      baseCharge: 5000,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 50,
      extraHourRate: 500,
      nightCharges: 1000,
      outstationMinKms: 250,
      outstationRate: 50,
      driverAllowance: 1000,
      localPackages: {
        '2hr-20km': 3000,
        '3hr-30km': 3200,
        '4hr-40km': 3400,
        '5hr-50km': 3600,
        '6hr-60km': 3800,
        '7hr-70km': 4000,
        '8hr-80km': 4200,
        '9hr-90km': 4400,
        '10hr-100km': 4600
      }
    },
    'Tempo Traveller': {
      baseCharge: 3500,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 35,
      extraHourRate: 350,
      nightCharges: 700,
      outstationMinKms: 250,
      outstationRate: 35,
      driverAllowance: 700,
      localPackages: {
        '2hr-20km': 2000,
        '3hr-30km': 2200,
        '4hr-40km': 2400,
        '5hr-50km': 2600,
        '6hr-60km': 2800,
        '7hr-70km': 3000,
        '8hr-80km': 3200,
        '9hr-90km': 3400,
        '10hr-100km': 3600
      }
    }
  },
  'Mumbai': {
    'Sedan': {
      baseCharge: 1600,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 20,
      extraHourRate: 160,
      nightCharges: 320,
      outstationMinKms: 250,
      outstationRate: 20,
      driverAllowance: 320
    },
    'SUV': {
      baseCharge: 2100,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 24,
      extraHourRate: 210,
      nightCharges: 420,
      outstationMinKms: 250,
      outstationRate: 24,
      driverAllowance: 420
    },
    'Premium Sedan': {
      baseCharge: 2300,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 26,
      extraHourRate: 230,
      nightCharges: 460,
      outstationMinKms: 250,
      outstationRate: 26,
      driverAllowance: 460
    },
    'Premium SUV': {
      baseCharge: 3200,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 32,
      extraHourRate: 320,
      nightCharges: 640,
      outstationMinKms: 250,
      outstationRate: 32,
      driverAllowance: 640
    },
    'Luxury': {
      baseCharge: 5500,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 55,
      extraHourRate: 550,
      nightCharges: 1100,
      outstationMinKms: 250,
      outstationRate: 55,
      driverAllowance: 1100
    },
    'Tempo Traveller': {
      baseCharge: 3800,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 38,
      extraHourRate: 380,
      nightCharges: 760,
      outstationMinKms: 250,
      outstationRate: 38,
      driverAllowance: 760
    }
  },
  'Pune': {
    'Sedan': {
      baseCharge: 1400,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 17,
      extraHourRate: 140,
      nightCharges: 280,
      outstationMinKms: 250,
      outstationRate: 17,
      driverAllowance: 280
    },
    'SUV': {
      baseCharge: 1900,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 21,
      extraHourRate: 190,
      nightCharges: 380,
      outstationMinKms: 250,
      outstationRate: 21,
      driverAllowance: 380
    },
    'Premium Sedan': {
      baseCharge: 2100,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 23,
      extraHourRate: 210,
      nightCharges: 420,
      outstationMinKms: 250,
      outstationRate: 23,
      driverAllowance: 420
    },
    'Premium SUV': {
      baseCharge: 2900,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 29,
      extraHourRate: 290,
      nightCharges: 580,
      outstationMinKms: 250,
      outstationRate: 29,
      driverAllowance: 580
    },
    'Luxury': {
      baseCharge: 4800,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 48,
      extraHourRate: 480,
      nightCharges: 960,
      outstationMinKms: 250,
      outstationRate: 48,
      driverAllowance: 960
    },
    'Tempo Traveller': {
      baseCharge: 3300,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 33,
      extraHourRate: 330,
      nightCharges: 660,
      outstationMinKms: 250,
      outstationRate: 33,
      driverAllowance: 660
    }
  },
  'Bangalore': {
    'Sedan': {
      baseCharge: 1500,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 18,
      extraHourRate: 150,
      nightCharges: 300,
      outstationMinKms: 250,
      outstationRate: 18,
      driverAllowance: 300
    },
    'SUV': {
      baseCharge: 2000,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 22,
      extraHourRate: 200,
      nightCharges: 400,
      outstationMinKms: 250,
      outstationRate: 22,
      driverAllowance: 400
    },
    'Premium Sedan': {
      baseCharge: 2200,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 24,
      extraHourRate: 220,
      nightCharges: 440,
      outstationMinKms: 250,
      outstationRate: 24,
      driverAllowance: 440
    },
    'Premium SUV': {
      baseCharge: 3000,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 30,
      extraHourRate: 300,
      nightCharges: 600,
      outstationMinKms: 250,
      outstationRate: 30,
      driverAllowance: 600
    },
    'Luxury': {
      baseCharge: 5000,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 50,
      extraHourRate: 500,
      nightCharges: 1000,
      outstationMinKms: 250,
      outstationRate: 50,
      driverAllowance: 1000
    },
    'Tempo Traveller': {
      baseCharge: 3500,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 35,
      extraHourRate: 350,
      nightCharges: 700,
      outstationMinKms: 250,
      outstationRate: 35,
      driverAllowance: 700
    }
  },
  'Kolkata': {
    'Sedan': {
      baseCharge: 1300,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 16,
      extraHourRate: 130,
      nightCharges: 260,
      outstationMinKms: 250,
      outstationRate: 16,
      driverAllowance: 260
    },
    'SUV': {
      baseCharge: 1800,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 20,
      extraHourRate: 180,
      nightCharges: 360,
      outstationMinKms: 250,
      outstationRate: 20,
      driverAllowance: 360
    },
    'Premium Sedan': {
      baseCharge: 2000,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 22,
      extraHourRate: 200,
      nightCharges: 400,
      outstationMinKms: 250,
      outstationRate: 22,
      driverAllowance: 400
    },
    'Premium SUV': {
      baseCharge: 2800,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 28,
      extraHourRate: 280,
      nightCharges: 560,
      outstationMinKms: 250,
      outstationRate: 28,
      driverAllowance: 560
    },
    'Luxury': {
      baseCharge: 4500,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 45,
      extraHourRate: 450,
      nightCharges: 900,
      outstationMinKms: 250,
      outstationRate: 45,
      driverAllowance: 900
    },
    'Tempo Traveller': {
      baseCharge: 3200,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 32,
      extraHourRate: 320,
      nightCharges: 640,
      outstationMinKms: 250,
      outstationRate: 32,
      driverAllowance: 640
    }
  },
  'Hyderabad': {
    'Sedan': {
      baseCharge: 1400,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 17,
      extraHourRate: 140,
      nightCharges: 280,
      outstationMinKms: 250,
      outstationRate: 17,
      driverAllowance: 280
    },
    'SUV': {
      baseCharge: 1900,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 21,
      extraHourRate: 190,
      nightCharges: 380,
      outstationMinKms: 250,
      outstationRate: 21,
      driverAllowance: 380
    },
    'Premium Sedan': {
      baseCharge: 2100,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 23,
      extraHourRate: 210,
      nightCharges: 420,
      outstationMinKms: 250,
      outstationRate: 23,
      driverAllowance: 420
    },
    'Premium SUV': {
      baseCharge: 2900,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 29,
      extraHourRate: 290,
      nightCharges: 580,
      outstationMinKms: 250,
      outstationRate: 29,
      driverAllowance: 580
    },
    'Luxury': {
      baseCharge: 4800,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 48,
      extraHourRate: 480,
      nightCharges: 960,
      outstationMinKms: 250,
      outstationRate: 48,
      driverAllowance: 960
    },
    'Tempo Traveller': {
      baseCharge: 3300,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 33,
      extraHourRate: 330,
      nightCharges: 660,
      outstationMinKms: 250,
      outstationRate: 33,
      driverAllowance: 660
    }
  },
  'Chennai': {
    'Sedan': {
      baseCharge: 1300,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 16,
      extraHourRate: 130,
      nightCharges: 260,
      outstationMinKms: 250,
      outstationRate: 16,
      driverAllowance: 260
    },
    'SUV': {
      baseCharge: 1800,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 20,
      extraHourRate: 180,
      nightCharges: 360,
      outstationMinKms: 250,
      outstationRate: 20,
      driverAllowance: 360
    },
    'Premium Sedan': {
      baseCharge: 2000,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 22,
      extraHourRate: 200,
      nightCharges: 400,
      outstationMinKms: 250,
      outstationRate: 22,
      driverAllowance: 400
    },
    'Premium SUV': {
      baseCharge: 2800,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 28,
      extraHourRate: 280,
      nightCharges: 560,
      outstationMinKms: 250,
      outstationRate: 28,
      driverAllowance: 560
    },
    'Luxury': {
      baseCharge: 4500,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 45,
      extraHourRate: 450,
      nightCharges: 900,
      outstationMinKms: 250,
      outstationRate: 45,
      driverAllowance: 900
    },
    'Tempo Traveller': {
      baseCharge: 3200,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 32,
      extraHourRate: 320,
      nightCharges: 640,
      outstationMinKms: 250,
      outstationRate: 32,
      driverAllowance: 640
    }
  },
  'Goa': {
    'Sedan': {
      baseCharge: 1200,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 15,
      extraHourRate: 120,
      nightCharges: 240,
      outstationMinKms: 250,
      outstationRate: 15,
      driverAllowance: 240
    },
    'SUV': {
      baseCharge: 1700,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 19,
      extraHourRate: 170,
      nightCharges: 340,
      outstationMinKms: 250,
      outstationRate: 19,
      driverAllowance: 340
    },
    'Premium Sedan': {
      baseCharge: 1900,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 21,
      extraHourRate: 190,
      nightCharges: 380,
      outstationMinKms: 250,
      outstationRate: 21,
      driverAllowance: 380
    },
    'Premium SUV': {
      baseCharge: 2700,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 27,
      extraHourRate: 270,
      nightCharges: 540,
      outstationMinKms: 250,
      outstationRate: 27,
      driverAllowance: 540
    },
    'Luxury': {
      baseCharge: 4200,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 42,
      extraHourRate: 420,
      nightCharges: 840,
      outstationMinKms: 250,
      outstationRate: 42,
      driverAllowance: 840
    },
    'Tempo Traveller': {
      baseCharge: 3000,
      baseKms: 80,
      baseHours: 8,
      extraKmRate: 30,
      extraHourRate: 300,
      nightCharges: 600,
      outstationMinKms: 250,
      outstationRate: 30,
      driverAllowance: 600
    }
  }
};

export const cities = Object.keys(pricingData);

export const carTypes = ['Sedan', 'SUV', 'Premium Sedan', 'Premium SUV', 'Luxury', 'Tempo Traveller'];
